import { render, staticRenderFns } from "./currency-sources-stat.vue?vue&type=template&id=8989a97a&scoped=true&"
import script from "./currency-sources-stat.vue?vue&type=script&lang=js&"
export * from "./currency-sources-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8989a97a",
  null
  
)

export default component.exports